/**
 * 权限控制器-所有不能通过权限的都跳转到401
 * 权限管理-核心方法
 */
import Cookies from "js-cookie";
import router from "./router";
// import { MessageBox } from "mint-ui";
import { Dialog } from 'vant'
import { getToken, removeToken } from "@/utils/auth"; // getToken from cookie - 获取token



// 权限判断功能
function hasPermission(roles, permissionRoles) {
  console.log("对该页面进行权限判断===》");
  if (roles.indexOf("agent") >= 0) return true; // AMS-ADMIN为该系统的最高管理员权限 permission passed directly
  if (!permissionRoles) return true;
  return roles.some(role => permissionRoles.indexOf(role) >= 0);
}
// 白名单-不进行权限判断
const whiteList = ["/login", '/error', '/wx/error', '/register','/goods','/user/password','/officialHome']; // no redirect whitelist

router.beforeEach((to, from, next) => {
  // 初始化当前客户端访问模式
  console.log(getToken())
  if (getToken()) {
    // determine if there has token
    /* has token*/
    console.log(to)
    if (to.path === "/login" || to.path === "/shop/login") {
      removeToken();
      sessionStorage.clear();
      if (to.path === "/login" && localStorage.getItem('userType') == 2) {
        sessionStorage.clear();
        removeToken();

        next()
      } else if (to.path === "/shop/login" && localStorage.getItem('userType') == 1) {
        removeToken();
        sessionStorage.clear();

        next()
      } else {
        console.log('回到首页')
        next({ path: "/" });
      }
    } else {
      // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
      // if (hasPermission(store.getters.roles, to.meta.roles)) {
      //   console.log("通过权限认证==》");
      //   next();
      // } else {
      //   next({ path: "/401", replace: true, query: { noGoBack: true } });
      // }
      // 可删 ↑
      next()
    }
  } else {
    /* has no token*/
    console.log(whiteList.indexOf(to.path))
    console.log(to.path)
    if (
      whiteList.indexOf(to.path) !== -1
    ) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next();
      if (localStorage.getItem('userType') == 2) {

        next(`/shop/login`);
      } else {

        next(`/login`);
      }
      // 否则全部重定向到登录页
    }
  }
});

router.afterEach(() => {
  window.scrollTo(0,0)
});



// WEBPACK FOOTER //
// ./src/permission.js